import React, { Component, createRef} from "react";
import PropTypes from "prop-types";
import {isEmpty} from "ramda";


const alertMessageRef = createRef();

class BaseAlert extends Component {
	static propTypes = {
		children: PropTypes.instanceOf(Object).isRequired,
		visible: PropTypes.bool.isRequired,
		icon: PropTypes.string,
		type: PropTypes.string,
	};

	componentDidUpdate(){
		alertMessageRef.current.scrollIntoView({
		 	behavior: 'smooth',
		 	block: 'start',
		});
	}

	render() {
		const { children, visible } = this.props;
		let icon = false;
		let type = 'info'
		
		if (typeof this.props.type !== 'undefined') {
			type = this.props.type;
		}

		if (typeof this.props.icon !== 'undefined') {
			icon = this.props.icon;
		}

		return (
			<div className={`alert alert-${type} ${!visible ? "hidden" : ""}`} role="alert">
				{icon && (
					<div className="alert--icon">
						<i className={icon}/>
					</div>
				)}
				<div className="alert--message" ref={alertMessageRef}>
					{children}
				</div>
			</div>
		);
	}
}

export default BaseAlert;
